import { ThemeDataProps } from "types/themeData/themeData.interface";

export function filterEdgesByTag(arr: any, tag: string, shopifyThemesData: ThemeDataProps) {
  if (tag === "Shopify") return shopifyThemesData;

  return arr.filter((item: any) => {
    if (tag == "Figma") return item.node.frontmatter.tags == tag;

    return item.node.frontmatter.tags.includes(tag);
  });
}

export function filterEdgesByBothTag(arr: any) {
  return arr.filter((item: any) => {
    const tags = item.node.frontmatter.tags;

    return tags.includes("Figma") && tags.includes("Shopify");
  });
}

export function matchEdgesByTitle(arr: any, title: string) {
  const regex = new RegExp(title, "i");

  return arr.filter((item: any) => regex.test(item.node.frontmatter.title));
}

export function filterEdgesByTechnologyTitle(
  arr: any,
  technologyTitle: string
) {
  return arr.filter((item: any) => {
    const technologies = item.node.frontmatter.technologies;

    for (let i = 0; i < technologies.length; i++) {
      if (technologies[i].title === technologyTitle) {
        return true;
      }
    }

    return false;
  });
}

// * Handles edge case when there are less number of modified(filtered) data than 'limit' number (use this to force fixed number of items, like homepage items)
export function limitEdges(
  limitNumber: number,
  modifiedFrontmatterEdges: any,
  parentFrontmatterEdges: any
) {
  if (limitNumber > modifiedFrontmatterEdges.length) {
    modifiedFrontmatterEdges = Array.from(
      new Set(
        modifiedFrontmatterEdges.concat(
          filterEdgesByTag(parentFrontmatterEdges, "Popular")
        )
      )
    );
  }

  return modifiedFrontmatterEdges.slice(0, limitNumber);
}

export function removeEdgesBySlug(arr: any, slug: string) {
  return arr.filter((item: any) => item.node.frontmatter.slug != slug);
}
